module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Bold-Rotalic.a0144a52.woff";